var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper expired-info"},[_c('p',{attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.$t('global.expiredMessage')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }